'use strict';

let formValidation = require('../components/formValidation');

const elements = {
  form: {
    submit: $('form.edit-profile-form button[type="submit"]'),
    firstname: $('#edit-profile-form-fname'),
    lastname: $('#edit-profile-form-lname'),
    email: $('#edit-profile-form-email'),
    birthday: $('#edit-profile-form-birthday'),
    postalCode: $('#edit-profile-form-postalCode'),
    prefixcode: $('#edit-profile-prefixcode'),
    phone: $('#edit-profile-phone'),
    gender: $('select[name$="dwfrm_profile_customer_gender"]'),
    address: $('#edit-profile-address'),
    city: $('#edit-profile-city'),
    state: $('#edit-profile-state'),
    country: $('#edit-profile-country'),
    coincard: $('#edit-profile-form-coincard')
  }
}

function displayMessage(success, msg, form) {
  const span = document.createElement('DIV');
  span.classList.add('alert', 'card-custom', `${success ? 'alert-success' : 'alert-danger'}`);
  span.setAttribute('role', 'alert');
  span.setAttribute('aria-live', 'polite');
  span.innerHTML = msg;
  form.parentNode.appendChild(span);

  setTimeout(function () {
    span.remove();
  }, 5000);
}

function getOTPData () {
  if (window.hasOwnProperty('OTPResource')) {
    return {
      sendURL: window.OTPResource.urls.send,
      verifyURL: window.OTPResource.urls.verify,
      sendTitleEmail: window.OTPResource.messages.sendTitleEmail,
      sendTitlePhone:  window.OTPResource.messages.sendTitlePhone,
      sendBtnSubmit: window.OTPResource.messages.sendBtnSubmit,
      sendNewOTP: window.OTPResource.messages.sendNewOTP,
      verifySuccessTitle: window.OTPResource.messages.verifySuccessTitle,
      verifyErrorTitle: window.OTPResource.messages.verifyErrorTitle,
      genericError: window.OTPResource.messages.verifyErrorTitle,
      resendOTP: window.OTPResource.messages.resendOTPMessage
    }
  } else {
    throw 'OTP Error: Not been included _tags/otp-resources.isml inside of _tags/main-head'; 
  }
};

let currentPinId = null;

function UpdatePinId(newPinId) {
  if (newPinId !== undefined) {
    currentPinId = newPinId;
  }
  return currentPinId;
}

function submitProfile (e, body) {
  let $form =  $('form.edit-profile-form');
  let url = $form.attr('action');
  $('form.edit-profile-form').trigger('profile:edit', e);
  $.ajax({
    url: url,
    type: 'post',
    dataType: 'json',
    headers: {
        "otp_code": body.otp,
        "otp_id": body.data.pinId,
        "otp_field": body.data.field
    },
    data: $form.serialize(),
    success: function (data) {
      if (!data.success) {
        window.$.spinner().stop();
        const editProfileForm = $('.edit-profile-form');
        const msg = data.errorMsg
        editProfileForm.append('<div class="alert edit-profile-alert alert-danger card-custom text-center" role="alert">' + msg + '</div>');
        setTimeout(function () {
          $('.edit-profile-alert').remove();
        }, 5000);
      } else {
        const editProfileForm = $('.edit-profile-form');
        const msg = editProfileForm.data('success');
        editProfileForm.append('<div class="alert edit-profile-alert alert-success card-custom text-center" role="alert">' + msg + '</div>');
        setTimeout(function () {
          $('.edit-profile-alert').remove();
          window.$.spinner().stop();
          location.href = data.redirectUrl;
        }, 5000);
      }
    },
    error: function (err) {
      if (err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
      }
      window.$.spinner().stop();
    },
  });
return false;
};

function SubmitVerify (dataField, e) {
  var OTPData = getOTPData();
  let form = $('#OTP-Verify-Form');
  dataField.pinId = UpdatePinId();
  var body = { 
    otp: $('#OTP-Verify-Form').find('input[name="otp"]').val(),
    data: dataField
  }
  let url = form.attr('action');  //OTP-Verify
  $.post({
    url: url,
    type: 'post',
    dataType: 'json',
    data: body,
    success: function (data) {
      if (!data.valid) {
        window.$.spinner().stop();
        $('body').trigger('otp:send:error', data);
        $('#OTP-Verify-Form').find('.message-error').html(OTPData.verifyErrorTitle);
        return false;
      } else {
        $('body').trigger('otp:send:success', data);
        OTPSuccess()
        submitProfile(e, body)
        setTimeout(() => {
          OTPDestroy();
        }, 1200)
      }
    },
    error: function (err) {
      $('body').trigger('otp:send:error', err);
      $('#OTP-Verify-Form').find('.message-error').html(OTPData.genericError);
      window.$.spinner().stop();
      return false; 
    },
  });
};

function OTPSuccess () {
  var OTPData = getOTPData();
  $('#OTP-Verify-Form').html(`<div class="success">${OTPData.verifySuccessTitle}</div>`);
};

function OTPDestroy () {
  window.onRecaptchaExpired();
  $('#OTP-Container').remove();
};

function OTPSend (data) {
  var OTPData = getOTPData();
  $('#OTP-Verify-Form').find('input[name="otp"]').val('');
  $('#OTP-Verify-Form').find('.message-error').html('');
  return $.post({
    url: OTPData.sendURL,
    data: JSON.stringify({ data }),
    dataType: 'json',
    contentType: 'application/json',
    success: function (data) {
      if (data.send) {
        var OTPForm = $('#OTP-Verify-Form');
        UpdatePinId(data.pinId);
        const msg = OTPForm.data('success');
        OTPForm.append('<div class="alert edit-profile-alert alert-success card-custom text-center" role="alert">' + msg + '</div>');
        setTimeout(function () {
          $('.edit-profile-alert').remove();
        }, 5000);
      }
    }
  });
};

function submitFormWithoutOTP () {
    let $form = $('form.edit-profile-form');
    let url = $form.attr('action');
    $.ajax({
      url: url,
      type: 'post',
      dataType: 'json',
      data: $form.serialize(),
      success: function (data) {
        if (!data.success) {
          window.$.spinner().stop();
          formValidation($form, data);
        } else {
          // location.href = data.redirectUrl;
          // window.location.reload();
          const editProfileForm = $('.edit-profile-form');
          const msg = editProfileForm.data('success');
          editProfileForm.append('<div class="alert edit-profile-alert alert-success card-custom text-center" role="alert">' + msg + '</div>');

          setTimeout(function () {
            $('.edit-profile-alert').remove();
            window.$.spinner().stop();
            location.href = data.redirectUrl;
          }, 5000);
        }
      },
      error: function (err) {
        if (err.responseJSON.redirectUrl) {
          window.location.href = err.responseJSON.redirectUrl;
        }
        window.$.spinner().stop();
      },
    });
};

function HandlePasswordField () {
  $('form.edit-profile-form #email').removeClass('is-invalid');
  if ($('form.edit-profile-form #confirmEmail').val() !== $('form.edit-profile-form #email').val()) {
    var element = document.getElementById('confirm-password');
    element.classList.remove('d-none');
    $('form.edit-profile-form #password').attr('required', 'required');
  } else {
    $('form.edit-profile-form #confirm-password').addClass('d-none');
    $('form.edit-profile-form #password').removeAttr('required');
  }
};

module.exports = {
  checkChangedEmail: () => {
    if ($('form.edit-profile-form #confirmEmail').val() === $('form.edit-profile-form #email').val()) {
      $('form.edit-profile-form #confirm-password').addClass('d-none');
      $('form.edit-profile-form #password').removeAttr('required');
    }
  },
  checkEmail: () => {
  $('form.edit-profile-form #email').on('blur', function (e) {
      e.preventDefault();
      if ($('form.edit-profile-form #confirmEmail').val() !== $('form.edit-profile-form #email').val()) {
        var mail = $('form.edit-profile-form #email').val();
        var currentMail = $('form.edit-profile-form #confirmEmail').val();
        var url = $('form.edit-profile-form #email').attr('data-check-datahub-url');
        var isInError = $('div.col--email.col-md-6 div.error');
        if (mail && mail.length > 0 && isInError.length == 0) {
          var errorAlert = $('div.alert.alert-danger.alert-dismissible');
          if (errorAlert && errorAlert.length > 0) {
            errorAlert.remove();
          }
          $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {
              mail : mail,
              currentMail : currentMail
            },
            success: function (data) {
              if(data.valid) {
                $('form.edit-profile-form button').removeAttr('disabled');
                $('div.alert.alert-danger.alert-dismissible').remove();
                HandlePasswordField()
              } else if (data.errorMsg){
                var errorHtml = '<div class="alert alert-danger alert-dismissible ' +
                  'fade show" role="alert">' +
                  data.errorMsg + '</div>';

                $('form.edit-profile-form button').attr('disabled', true);
                $('form.edit-profile-form #confirm-password').addClass('d-none');
                $('form.edit-profile-form').prepend(errorHtml);
              }
            },
            error: function () {
              $('form.edit-profile-form button').removeAttr('disabled');
            },
          });
        }
      } else {
        $('form.edit-profile-form #confirm-password').addClass('d-none');
        $('form.edit-profile-form #password').removeAttr('required');
        $('form.edit-profile-form button').removeAttr('disabled');
        $('div.alert.alert-danger.alert-dismissible').remove();
      }
    })
  },

  closeModalOTP: () => {
    $(document).mouseup(function(e){
      var container = $("#OTP-Verify-Form");
   
      if(container.length && !container.is(e.target) && container.has(e.target).length === 0){
          OTPDestroy();
      }
    });
  },

  SetPrivacyFlag: () => {
    // Raggruppiamo gli elementi in un oggetto
    const privacyOptions = {
        email: ['#privacyEmail-option-1', '#privacyEmail-option-2'],
        sms: ['#privacySms-option-1', '#privacySms-option-2'],
        telemarketing: ['#privacyTelemarketing-option-1', '#privacyTelemarketing-option-2'],
        directMail: ['#privacyDirectEmail-option-1', '#privacyDirectEmail-option-2']
    };

    const setCheckedState = (state) => {
        $('.privacyCommunicationChannel input').attr('class', state ? 'enabled' : 'disabled');

        // Impostiamo la selezione degli input dinamicamente
        Object.values(privacyOptions).forEach(([option1, option2]) => {
            $(state ? option1 : option2).prop("checked", true);
        });

        // Aggiorniamo la disponibilità degli input
        toggleOption1Inputs(!state);  // Abilitiamo o disabilitiamo option1 in base allo stato
    };

    const toggleOption1Inputs = (enable) => {
        Object.values(privacyOptions).forEach(([option1]) => {
            $(option1).prop('disabled', !enable); // Disabilita se enable è false
        });
    };

    const updatePrivacy2Option2 = () => {
        const allChecked = Object.values(privacyOptions).every(([_, option2]) => $(option2).prop("checked"));
        $('#privacy2-option-2').prop("checked", allChecked);
        toggleOption1Inputs(!allChecked); // Disabilita option1 se tutti i option2 sono selezionati
    };

    // Assegniamo gli eventi di click
    $('#privacy2-option-1').on('click', () => {
        setCheckedState(true);
        updatePrivacy2Option2();  // Aggiunta della chiamata a updatePrivacy2Option2
    });
    $('#privacy2-option-2').on('click', () => {
        setCheckedState(false);
        updatePrivacy2Option2();  // Chiamata per garantire che la logica venga eseguita anche qui
    });

    // Aggiungiamo eventi di change per ciascun input option-2 per aggiornare privacy2-option-2
    Object.values(privacyOptions).forEach(([, option2]) => {
        $(option2).on('change', updatePrivacy2Option2);
    });

    // Controllo iniziale se #privacy2-option-2 è selezionato
    if ($('#privacy2-option-2').prop('checked')) {
        setCheckedState(false); // Disabilita option1
    } else {
        toggleOption1Inputs(true); // Altrimenti, li rende cliccabili
    }
},

submitPrivacyForm: function () {
  $('edit-privacy-form').on('bouncerFormValid', function (e) {
    let $form = $(this);
    e.preventDefault();
    let url = $form.attr('action');
    window.$.spinner().start();
    $('edit-privacy-form').trigger('profile:edit', e);
    $.ajax({
      url: url,
      type: 'post',
      dataType: 'json',
      data: $form.serialize(),
      success: function (data) {
        console.log('data', data);
        window.$.spinner().stop();
        if (!data.success) {
          formValidation($form, data);
        } else {
          // location.href = data.redirectUrl;
          // window.location.reload();
          const editProfileForm = $('.edit-privacy-form');
          const msg = editProfileForm.data('success');
          editProfileForm.append('<div class="alert edit-profile-alert alert-success card-custom text-center" role="alert">' + msg + '</div>');

          setTimeout(function () {
            $('.edit-profile-alert').remove();
            location.href = data.redirectUrl;
          }, 5000);
        }
      },
      error: function (err) {
        if (err.responseJSON.redirectUrl) {
          window.location.href = err.responseJSON.redirectUrl;
        }
        window.$.spinner().stop();
      },
    });
    return false;
  });
},

  checkValidateForm: function (){
    $('form.edit-profile-form').on('bouncerFormValid', function (e) {
      window.$.spinner().start();
      let $form = $(this);
      e.preventDefault();
      let url = $form.attr('data-checkform');
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
          window.$.spinner().stop();
          if (!data.success) {
            formValidation($form, data);
          } else {
            if (data.requireOTP){
              var OTPData = getOTPData();
              currentPinId = data.pinId;
              var dataField = {
               field: data.field,
               pinId: data.pinId,
               value: data.value
              }
              var Form = `
              <form id="OTP-Verify-Form" action="${OTPData.verifyURL}" data-success="${OTPData.resendOTP}" method="POST">
                <div class="title-otp">${data.field == 'phone' ? OTPData.sendTitlePhone : OTPData.sendTitleEmail}</div>
                <div>${data.text}</div>
                <input name="otp" class="" required />
                <button type="submit" class="btn btn-secondary">${OTPData.sendBtnSubmit}</button>
                <div class="message-error"></div>
                <div class="retry-OTP">${OTPData.sendNewOTP}</div>
              </form>
            `
              var container = $(document.createElement('div'));
              container.attr('id', 'OTP-Container')
                  .attr('class', 'OTP-Modal')
                  .html(Form);
              container.find('form').on('submit', (e) => SubmitVerify(dataField, e));
              container.find('form').find('.retry-OTP').on('click', () => OTPSend(dataField));
              $('body').append(container);
            } else {
              submitFormWithoutOTP();
            }
          }
        },
        error: function (err) {
          if (err) {
            console.log('err:', err)
          }
          window.$.spinner().stop();
          window.onRecaptchaExpired();
        },
      });
      return false;
    });
  },

  submitPassword: function () {
    $('form.change-password-form').on('bouncerFormValid', function (e) {
      let $form = $(this);
      e.preventDefault();
      let url = $form.attr('action');
      window.$.spinner().start();
      $('form.change-password-form').trigger('password:edit', e);
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
          if (!data.success) {
            formValidation($form, data);
          } else {
            location.href = data.redirectUrl;
          }
          window.$.spinner().stop();
        },
        error: function (err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          }
          window.$.spinner().stop();
        },
      });
      return false;
    });
  },

  submitPrivacyPolicy: function () {
    $('form.edit-privacy-form').on('bouncerFormValid', function (e) {
      let $form = $(this);
      e.preventDefault();
      let url = $form.attr('action');
      window.$.spinner().start();
      $('form.edit-privacy-form').trigger('privacy:edit', e);
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
          if (!data.success) {
            window.$.spinner().stop();
            formValidation($form, data);
          } else {
            const editProfileForm = $('.edit-privacy-form');
            const msg = editProfileForm.data('success');
            editProfileForm.append('<div class="alert edit-privacy-alert alert-success card-custom text-center" role="alert">' + msg + '</div>');

            setTimeout(function () {
              $('.edit-privacy-alert').remove();
              window.$.spinner().stop();
              location.href = data.redirectUrl;
            }, 5000);
          }
        },
        error: function (err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          }
          window.$.spinner().stop();
        },
      });
      return false;
    });
  },

  activateGiftCard: function () {
    $('form.new-giftcard').on('bouncerFormValid', function (e) {
      let form = e.target;
      e.preventDefault();
      let url = $(form).attr('action');
      window.$.spinner().start();
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $(form).serialize(),
        success: function (data) {
          if (data.success) {
            window.$.spinner().stop();
            displayMessage(true, data.msg, form);
            if (data.redirectUrl) {
              setTimeout(function () {
                window.$.spinner().stop();
                window.location.href = data.redirectUrl;
              }, 3000);
            }
          } else {
            window.$.spinner().stop();
            displayMessage(false, data.msg, form);
          }
        },
        error: function (err) {
          if (err.msg) {
            displayMessage(false, err.msg, form);
          }
          window.$.spinner().stop();
        },
      });
      return false;
    });
  },

  deleteGiftCard: function () {
    $('.giftcard-card').on('click', '.remove-giftcard', function (e) {
      e.preventDefault();
      let target = e.target;
      let url = $(this).data('action');
      window.$.spinner().start();
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        success: function (data) {
          window.$.spinner().stop();
          if (data.success) {
            displayMessage(true, data.msg, target);
          } else {
            displayMessage(false, data.msg, target);
          }
          if (data.redirect) {
            window.location.href = data.redirect;
          }
        },
        error: function (err) {
          if (err.msg) {
            displayMessage(false, err.msg, target);
          }
          window.$.spinner().stop();
        },
      });
      return false;
    });
  },

  CheckPreixCodeFiled: () => {
    elements.form.prefixcode.val($('form.edit-profile-form #prefixcode').val());
  },

  UpdatePreixCodeFiled: () => {
    $('form.edit-profile-form #prefixcode').on('change', () => {
      elements.form.prefixcode.val($('form.edit-profile-form #prefixcode').val());
    })
  },

  checkCountryField: () => {
    if ($('form.edit-profile-form #country').val() !== 'IT'){
      console.log('checkCountryField 1');

      $('form.edit-profile-form .state-col').addClass('d-none');
      elements.form.state.removeAttr('required');
      var regexStandard = $('form.edit-profile-form #postalCode').attr('data-regex');
      var postalCodeRegex = $('form.edit-profile-form #postalCode').attr("pattern");
      if (postalCodeRegex && postalCodeRegex!=regexStandard) {
        $('form.edit-profile-form #postalCode').attr("pattern", regexStandard);
      }
    } else {
      console.log('checkCountryField 2', elements.form.state);
      elements.form.state.attr('required', 'required');
    }
  },

  updateCountryCode: () => {
    $('form.edit-profile-form #country').on('change', () => {
      console.log('updateCountryCode change');
      elements.form.country.val($('form.edit-profile-form #country').val());
      if ($('form.edit-profile-form #country').val() !== 'IT') {
        console.log('updateCountryCode 1', elements.form.country.val());

        $('form.edit-profile-form .state-col').addClass('d-none');
        elements.form.state.removeAttr('required');
        $('form.edit-profile-form #postalCode').val('');
        $('form.edit-profile-form #postalCode').removeAttr('required').removeClass('error');
        $('form.edit-profile-form #state').val('');
        var regexStandard = $('form.edit-profile-form #postalCode').attr('data-regex');
        var postalCodeRegex = $('form.edit-profile-form #postalCode').attr("pattern");
        if (postalCodeRegex && postalCodeRegex!=regexStandard) {
          $('form.edit-profile-form #postalCode').attr("pattern", regexStandard);
        }
        $('form.edit-profile-form #state').val('');
        elements.form.state.val($('form.edit-profile-form #state').val());
      } else {
        console.log('updateCountryCode 2', elements.form.country.val());
        $('form.edit-profile-form #postalCode').attr('required', 'required').removeClass('error');

        var country = $('form.edit-profile-form #country').val()
        $.ajax({
          url: $('form.edit-profile-form #country').attr('data-url'),
          type: 'get',
          contentType: "application/json; charset=utf-8",
          data: country,
          success: function (data) {
            console.log('success');
            elements.form.state.attr('required', 'required');
            var options = [];
                    options.push('<option label="', $('form.edit-profile-form #state').attr('data-placeholder'), '" value=""/>');
                    $.each(data.jsonstates.data, function (index, value) {
                      options.push('<option id="', value.code, '" value="', value.code, '", regex-for-province="', value.regex, '">', value.description, '</option>');
                    });
            $('form.edit-profile-form #state').html(options.join(''));
            $('form.edit-profile-form .state-col').toggleClass('d-none');
          },
          error: function (err) {
            console.log('failed', err)
          },
        });
      }
    })
  },

  updateStateCode: () => {
    elements.form.state.val($('form.edit-profile-form #state').val());
    $('form.edit-profile-form #state').on('change', () => {
      console.log('updateStateCode 1 ');
      elements.form.state.val($('form.edit-profile-form #state').val());
      var optionId = $('form.edit-profile-form #state').val();
      if (optionId && optionId!="") {
        $('form.edit-profile-form #postalCode').attr("pattern", ($('form.edit-profile-form #state option#' + optionId).attr("regex-for-province")));
      } else {
        var regexStandard = $('form.edit-profile-form #postalCode').attr('data-regex');
        $('form.edit-profile-form #postalCode').attr("pattern", regexStandard);
      }
    })
  },

  // ManageRequiredFields: () => {
  //   if ($('form.edit-profile-form #registrationType').val() == 0) {
  //     $('form.edit-profile-form #phone').removeAttr('required');
  //     $('form.edit-profile-form #postalCode').removeAttr('required');
  //     $('form.edit-profile-form #gender').removeAttr('required');
  //     $('form.edit-profile-form #edit-profile-country').removeAttr('required');
  //     $('form.edit-profile-form #state').removeAttr('required');
  //     $('form.edit-profile-form #address').removeAttr('required');
  //     $('form.edit-profile-form #city').removeAttr('required');
  //     $('form #gender_select').removeAttr('required');
  //     $('form #country_select').removeAttr('required');
  //   }
  // }
};
